import { FC, MouseEventHandler } from "react";
import { Box, Button } from "@material-ui/core";
import useStyles from "../styles";
import { rightArrow } from "assets/icons";

interface ActionButtonProps {
  handleClose?: MouseEventHandler<HTMLElement> | undefined;
  label: string;
  bgColor: string;
  textColor?: string | undefined;
  isNext?: boolean;
  type?: "submit";
  textTransform?: string | undefined;
  cypressId?: string
  
}
const ActionButton: FC<ActionButtonProps> = ({
  handleClose,
  label,
  bgColor,
  textColor,
  isNext = false,
  type,
  textTransform,
  cypressId
}) => {
  const styles = useStyles();
  return (
    <Button
      autoFocus
      onClick={handleClose}
      className={styles.ActionButton}
      type={type}
      style={{ backgroundColor: bgColor, color: textColor }}
      data-cy={cypressId}
    >
      <label className={styles.buttonLabel} 
      // @ts-ignore
      style={{ textTransform: textTransform }}>{label}</label>

      {isNext && (
        <Box style={{ width: 20, height: 10, paddingLeft: 6, marginTop: -10 }}>
          <img src={rightArrow} alt="rightward arrow" width={15} height={10} />
        </Box>
      )}
    </Button>
  );
};

export default ActionButton;
